export const video = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2 5.5L1 6.5V21.5L2 22.5H19L20 21.5V17.8317L25.4592 21.3412L27 20.5V7.5L25.4592 6.65882L20 10.1683V6.5L19 5.5H2ZM20 12.546V15.454L25 18.6683V9.33167L20 12.546ZM18 12V7.5H3V20.5H18V16V12Z"
    fill="currentColor"
  />
);
